import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const FooterContainer = styled.footer`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  padding: ${theme.spacing.xl} 0;
`;

const Container = styled.div`
  max-width: ${theme.breakpoints.desktop};
  margin: 0 auto;
  padding: 0 ${theme.spacing.xl};
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.lg};
  }
`;

const FooterColumn = styled.div`
  h3 {
    color: ${theme.colors.white};
    margin-bottom: ${theme.spacing.lg};
    font-size: 1.2rem;
  }

  p {
    margin-bottom: ${theme.spacing.md};
    font-size: 0.9rem;
    opacity: 0.8;
  }
`;

const FooterList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: ${theme.spacing.sm};
    
    a {
      color: ${theme.colors.white};
      opacity: 0.8;
      transition: ${theme.transitions.default};
      font-size: 0.9rem;

      &:hover {
        opacity: 1;
        color: ${theme.colors.secondary};
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  margin-top: ${theme.spacing.lg};

  a {
    width: 40px;
    height: 40px;
    border-radius: ${theme.borderRadius.round};
    background-color: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: ${theme.transitions.default};

    &:hover {
      background-color: ${theme.colors.secondary};
      transform: translateY(-2px);
    }

    svg {
      width: 20px;
      height: 20px;
      fill: ${theme.colors.white};
    }
  }
`;

const BottomBar = styled.div`
  margin-top: ${theme.spacing.xl};
  padding-top: ${theme.spacing.lg};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  font-size: 0.9rem;
  opacity: 0.8;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterGrid>
          <FooterColumn>
            <h3>About Jupiter & Co</h3>
            <p>
              We are committed to providing the highest quality wood and timber products
              while maintaining sustainable practices and excellent customer service.
            </p>
            <SocialLinks>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zM17.5 6.5h.01" />
                </svg>
              </a>
            </SocialLinks>
          </FooterColumn>
          <FooterColumn>
            <h3>Quick Links</h3>
            <FooterList>
              <li><a href="#about">About Us</a></li>
              <li><a href="#products">Products</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
            </FooterList>
          </FooterColumn>
          <FooterColumn>
            <h3>Products</h3>
            <FooterList>
              <li><a href="#products">Hardwood Lumber</a></li>
              <li><a href="#products">Softwood Lumber</a></li>
              <li><a href="#products">Specialty Plywood</a></li>
              <li><a href="#products">Live Edge Slabs</a></li>
            </FooterList>
          </FooterColumn>
          <FooterColumn>
            <h3>Contact Info</h3>
            <FooterList>
              <li>41/A,Jeevanantham street,</li>
              <li>Kollampalayam,Erode-638002</li>
              <li>Phone: +91 9087188819, +91 9363618819</li>
              <li>Email: info@jupiternco.com</li>
            </FooterList>
          </FooterColumn>
        </FooterGrid>
        <BottomBar>
          <p>&copy; {new Date().getFullYear()} Jupiter & Co. All rights reserved.</p>
        </BottomBar>
      </Container>
    </FooterContainer>
  );
};

export default Footer; 